__turbopack_context__.v({
  "author": "_3XMoFq_author",
  "avatar": "_3XMoFq_avatar",
  "carousel": "_3XMoFq_carousel",
  "company": "_3XMoFq_company",
  "container": "_3XMoFq_container",
  "content": "_3XMoFq_content",
  "info": "_3XMoFq_info",
  "navButton": "_3XMoFq_navButton",
  "next": "_3XMoFq_next",
  "prev": "_3XMoFq_prev",
  "quote": "_3XMoFq_quote",
  "rating": "_3XMoFq_rating",
  "sectionTitle": "_3XMoFq_sectionTitle",
  "star": "_3XMoFq_star",
  "testimonial": "_3XMoFq_testimonial",
  "testimonials": "_3XMoFq_testimonials",
});
